<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Impostos
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters align="center">
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </v-row>
            </div>
          </v-row>
        </template>
        <template v-slot:item.imp_icms="{ item }">
          <div v-if="item.imp_icms">
            {{item.imp_icms}}%
          </div>
          <div v-if="!item.imp_icms">
            --
          </div>
        </template>
        <template v-slot:item.imp_pis="{ item }">
          <div v-if="item.imp_pis">
            {{item.imp_pis}}%
          </div>
          <div v-if="!item.imp_pis">
            --
          </div>
        </template>
        <template v-slot:item.imp_confins="{ item }">
          <div v-if="item.imp_confins">
            {{item.imp_confins}}%
          </div>
          <div v-if="!item.imp_confins">
            --
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center" v-if="nivelUsuarioApelido == 'M'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" :loading="salvando" :disabled="salvando" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" :loading="salvando" :disabled="salvando" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create" v-if="nivelUsuarioApelido === 'M'">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{imposto.uuid_imp_id ? 'Editar imposto' : 'Novo imposto'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formImposto">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="imposto.imp_estado"
                :items="estados"
                label="Estado*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                label="ICMS"
                outlined
                :loading="salvando"
                :disabled="salvando"
                type="number"
                v-model="imposto.imp_icms"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                label="PIS"
                outlined
                :loading="salvando"
                :disabled="salvando"
                type="number"
                v-model="imposto.imp_pis"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                label="COFINS"
                outlined
                :loading="salvando"
                :disabled="salvando"
                type="number"
                v-model="imposto.imp_confins"
                suffix="%"
              ></v-text-field>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditImposto()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Imposto
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelImpostoDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Imposto <b class="text-primary">{{imposto ? imposto.imp_estado : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelImpostoDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeImposto()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'

export default {
  data () {
    return {
      estados: [
        'Acre',
        'Alagoas',
        'Amapá',
        'Amazonas',
        'Bahia',
        'Ceará',
        'Espírito Santo',
        'Goiás',
        'Maranhão',
        'Mato Grosso',
        'Mato Grosso do Sul',
        'Minas Gerais',
        'Pará',
        'Paraíba',
        'Paraná',
        'Pernambuco',
        'Piauí',
        'Rio de Janeiro',
        'Rio Grande do Norte',
        'Rio Grande do Sul',
        'Rondônia',
        'Roraima',
        'Santa Catarina',
        'São Paulo',
        'Sergipe',
        'Tocantins',
        'Distrito Federal'
      ],
      total: 0,
      carregando: false,
      options: {},
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      search: '',
      searchFinal: null,
      headers: [
        { text: 'Estado', value: 'imp_estado', align: 'start' },
        { text: 'ICMS', value: 'imp_icms' },
        { text: 'PIS', value: 'imp_pis' },
        { text: 'CONFINS', value: 'imp_confins' }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      imposto: {
        uuid_imp_id: '',
        imp_estado: '',
        imp_icms: '',
        imp_pis: '',
        imp_confins: ''
      },
      nivelUsuarioApelido: ''
    }
  },
  watch: {
    search (val) {
      this.serchField = val
    },
    options: {
      handler () {
        this.getImpostos()
      },
      deep: true
    }
  },
  methods: {
    loadContent () {
      let filters = this.$route.query
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.loadFunctions()
    },
    loadFunctions () {
      this.getImpostos()
      this.loading = false
    },
    applyFilter () {
      let query = Object.assign({},
        this.searchFinal ? { busca: this.searchFinal } : ''
      )

      this.$router.replace({name: 'Imposto', query: query}).catch(() => {})
      this.dados = []
      this.getImpostos()
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    async getImpostos () {
      this.carregando = true
      this.dados = []
      this.total = 0
      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }
      let endpoint = ''
      if (this.searchFinal) {
        endpoint += '&busca=' + this.searchFinal
      }
      await Api.get(`imposto?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          if (res.data.data && res.data.data.length > 0) {
            this.dados = res.data.data
          }
          this.total = res.data.total
          this.carregando = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os impostos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    saveEditImposto () {
      if (!this.$refs.formImposto.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let dados = JSON.parse(JSON.stringify(this.imposto))
      let endpoint = 'imposto/novo'
      let editado = false
      if (dados.uuid_imp_id) {
        endpoint = 'imposto/edita'
        editado = true
      }
      Api.post(endpoint, dados)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Imposto atualizado com sucesso!' : 'Imposto adicionado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getImpostos()
        })
        .catch((error) => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeImposto () {
      this.salvando = true
      Api.delete(`imposto/remove/${this.imposto.uuid_imp_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getImpostos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover imposto!',
            color: 'error'
          })
        })
    },
    async openNovo (item) {
      this.salvando = true
      await Api.get('imposto/' + item.uuid_imp_id)
        .then(res => {
          this.imposto = JSON.parse(JSON.stringify(res.data))
          this.salvando = false
        })
        .catch(err => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar o imposto!',
            color: 'error'
          })
        })
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.imposto = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelImpostoDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.imposto = {
        uuid_imp_id: '',
        imp_estado: '',
        imp_icms: '',
        imp_pis: '',
        imp_confins: ''
      }
      if (this.$refs.formImposto) {
        this.$refs.formImposto.resetValidation()
      }
      this.dialogNovo = false
    },
    updateHeaders () {
      if (this.nivelUsuarioApelido === 'M') {
        this.headers.push(
          {
            text: 'Ações',
            value: 'actions',
            align: 'center',
            sortable: false,
            width: 110
          }
        )
      }
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.updateHeaders()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  height: 80px;
  margin-right: 15px;
  width: 80px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Imposto.vue